export default __webpack_public_path__ + "static/media/Bebas-Regular.44681718.otf";